module.exports = __webpack_public_path__ + "static/media/logo-exportafacil.1037caed.png";